module.exports = __webpack_public_path__ + "media/images/sidebar-photo-enterprise-954a67d77ac738c477e170779ae9372d403ccf1d56e2bfbd725a39ac029584d8.jpg";